import {AUTH_ERROR, AUTH_LOGOUT, AUTH_REQUEST, AUTH_SUCCESS, AUTH_UPDATE, AUTH_OPERATOR_UPDATE} from '@/store/mutation-types'
import ApiService from '@/service/ApiService'
import SubscriberService from '@/service/SubscriberService'
import {$_getApiHost} from '@/components/mixins/global/env'
import loggedUser from "../../components/mixins/global/logged-user";

const apiService = new ApiService($_getApiHost()+'/ui/')
const subscriberService = new SubscriberService(apiService)

const state = {
	userId: localStorage.getItem('user-id'),
	fullName: localStorage.getItem('full-name'),
	userName: localStorage.getItem('user-name'),
	userRole: localStorage.getItem('user-role'),
	userRoleList: localStorage.getItem('user-role-list') !== "undefined" ? JSON.parse(localStorage.getItem('user-role-list') || '{}') : {},
	operatorRoleList: localStorage.getItem('operator-role-list') !== "undefined" ? JSON.parse(localStorage.getItem('operator-role-list') || '{}') : {},
	userImage: localStorage.getItem('user-image'),
	operatorId: localStorage.getItem('operator-id'),
	operatorName: localStorage.getItem('operator-name'),
	loggedOperator: JSON.parse(localStorage.getItem('logged-operator') || '{"can_create_channel_package":false,"can_add_channels_to_own_channel_package":false,"can_add_channels_to_service":false}'),
	env: localStorage.getItem('env'),
	status: ''
}

const getters = {
	isAuthenticated: state => state.userId,
	getLoggedUserId: state => state.userId,
	getFullName: state => state.fullName,
	getUserName: state => state.userName,
	getUserRole: state => state.userRole,
	getUserRoleList: state => state.userRoleList,
	getOperatorRoleList: state => state.operatorRoleList,
	authStatus: state => state.status,
	userImage: state => state.userImage,
	operatorId: state => state.operatorId !== 'null' ? state.operatorId : null,
	getOperatorName: state => state.operatorName,
	getLoggedOperator: state => state.loggedOperator,
	getEnv: state => state.env,
}

const actions = {

	[AUTH_REQUEST]: ({commit, dispatch}, user) => {
		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST)
			subscriberService.login(user)
				.then(data => {
					const userData = data['user']
					localStorage.setItem('user-id', Number(userData.user_id))
					localStorage.setItem('full-name', userData.full_name)
					localStorage.setItem('user-name', userData.user_name)
					localStorage.setItem('user-role', userData.user_role)
					localStorage.setItem('user-role-list', JSON.stringify(userData.user_role_list))
					localStorage.setItem('operator-role-list', JSON.stringify(userData.operator_role_list))
					localStorage.setItem('user-image', userData.user_image)
					localStorage.setItem('operator-id', userData.operator_id)
					localStorage.setItem('operator-name', userData.operator_name)
					localStorage.setItem('logged-operator', 'empty_operator')
					localStorage.setItem('env', data['env'])

					commit(AUTH_SUCCESS, data)
					resolve(userData)
				})
				.catch(err => {
					console.log(err)

					localStorage.removeItem('user-id')
					localStorage.removeItem('full-name')
					localStorage.removeItem('user-name')
					localStorage.removeItem('user-role')
					localStorage.removeItem('user-role-list')
					localStorage.removeItem('operator-role-list')
					localStorage.removeItem('user-image')
					localStorage.removeItem('operator-id')
					localStorage.removeItem('operator-name')
					localStorage.removeItem('logged-operator')
					localStorage.removeItem('env')

					commit(AUTH_ERROR, err)
					reject(err)
				})
		})
	},
	[AUTH_UPDATE]: ({commit}, data) => {
		return new Promise((resolve) => {
			localStorage.setItem('full-name', data.full_name)
			localStorage.setItem('user-name', data.user_name)
			localStorage.setItem('user-role', data.user_role)
			localStorage.setItem('user-role-list', JSON.stringify(data.user_role_list))
			localStorage.setItem('operator-role-list', JSON.stringify(data.operator_role_list))
			localStorage.setItem('user-image', data.user_image)
			localStorage.setItem('operator-id', data.operator_id)
			localStorage.setItem('operator-name', data.operator_name)
			localStorage.setItem('logged-operator', JSON.stringify(data.logged_operator))
			commit(AUTH_UPDATE, data)
			resolve()
		})
	},
	[AUTH_OPERATOR_UPDATE]: ({commit}, data) => {
		return new Promise((resolve) => {
			localStorage.setItem('logged-operator', JSON.stringify(data['operator']))
			commit(AUTH_OPERATOR_UPDATE, data['operator'])
			resolve()
		})
	},
	[AUTH_LOGOUT]: ({commit, dispatch}) => {
		return new Promise((resolve, reject) => {
			subscriberService.logout()
				.then(resp => {
					console.log('logged out')
				})
				.catch(err => {
					console.log('logout error')
				})

			localStorage.removeItem('user-id')
			localStorage.removeItem('full-name')
			localStorage.removeItem('user-name')
			localStorage.removeItem('user-role')
			localStorage.removeItem('user-role-list')
			localStorage.removeItem('operator-role-list')
			localStorage.removeItem('user-image')
			localStorage.removeItem('operator-id')
			localStorage.removeItem('operator-name')
			localStorage.removeItem('logged-operator')
			localStorage.removeItem('env')
			localStorage.removeItem('owner-settings')
			localStorage.removeItem('owner-settings-hash')

			commit(AUTH_LOGOUT)
			resolve()
		})
	}
}

const mutations = {
	[AUTH_REQUEST]: (state) => {
		state.status = 'loading'
	},
	[AUTH_SUCCESS]: (state, data) => {
		const userData = data['user']
		state.status = 'success'
		state.userId = Number(userData.user_id)
		state.fullName = userData.full_name
		state.userName = userData.user_name
		state.userRole = userData.user_role
		state.userRoleList = ''
		state.userImage = userData.user_image
		state.operatorId = userData.operator_id
		state.operatorName = userData.operator_name
		state.loggedOperator = ''
		state.env = data['env']
		state.ownerSettings = ''
		state.ownerSettingsHash = ''
	},
	[AUTH_ERROR]: (state) => {
		state.status = 'error'
	},
	[AUTH_LOGOUT]: (state) => {
		state.status = ''
		state.userId = ''
		state.fullName = ''
		state.userName = ''
		state.userRole = ''
		state.userRoleList = ''
		state.userImage = ''
		state.operatorId = ''
		state.operatorName = ''
		state.loggedOperator = ''
		state.env = ''
		state.ownerSettings = ''
		state.ownerSettingsHash = ''
	},
	[AUTH_UPDATE]: (state, data) => {
		state.fullName = data.full_name
		state.userName = data.user_name
		state.userRole = data.user_role
		state.userRoleList = data.user_role_list
		state.operatorRoleList = data.operator_role_list
		state.userImage = data.user_image
		state.operatorId = data.operator_id
		state.operatorName = data.operator_name
		state.loggedOperator = data.logged_operator
	},
	[AUTH_OPERATOR_UPDATE]: (state, data) => {
		state.loggedOperator = data
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js